module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/transportation-unit-lvl3-50.aa7346f3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/transportation-unit-lvl3-50.png
// module id = 3577
// module chunks = 11